<template>
  <div class="upload">
    <el-upload
      class="upload-demo"
      :file-list="attach_urls"
      :action="UploadUrl()"
      :on-success="handleChange"
      :on-remove="handleRemove"
      :before-upload="beforeAvatarUpload"
      accept=".rar, .zip, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .jpg, .png"
      :data="uploadType"
    >
      <el-button size="small" icon="el-icon-upload">{{title}}</el-button>
      <div
        slot="tip"
        class="el-upload__tip"
      >支持扩展名：.rar .zip .doc .docx .xls .xslx .ppt .pptx .pdf .jpg .png格式,附件单个上传大小限制50M。</div>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "uploadAdjunct",
  props: {
    title: {
      type: String,
      default: "点击上传"
    },
    imgList:{
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: function() {
    return {
      uploadType: {
        tong: 'NewNoticeReview'
      },
      attach_urls: []
    };
  },
  created(){
    this.imgList.map(item=>{
      this.attach_urls.push({
        name: item,
        url: item
      });
    })
    console.log( this.attach_urls)
  },
  methods: {
    UploadUrl() {
      return "hcm/hcmWorkOrder/headUpload";
    },
    handleChange(file, fileList) {
      this.loadingUpDe = false;
      if (file.data.code == 2000) {
        this.$message.error(file.data.msg);
      }
      if (file.data.code == 0) {
        this.$message({
          message: file.data.msg,
          type: "success"
        });
      }
      this.attach_urls.push({
        name: fileList.name,
        url: fileList.response.data.data
      });
      console.log(this.attach_urls);
      this.$emit("attachUrls", this.attach_urls);
    },
    beforeAvatarUpload(file) {
      this.loadingUpDe = true;
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 50MB!");
      }
      return isLt2M;
    },
    handleRemove(file, fileList) {
      for (var i in this.attach_urls) {
        if (
          this.attach_urls[i].name == file.name &&
          this.attach_urls[i].url == file.url
        ) {
          this.attach_urls.splice(i, 1);
        }
      }
      this.$emit("attachUrls", this.attach_urls);
    },
    clearUrls() {
      this.attach_urls = [];
      this.$set(this, "attach_urls", []);
      console.log(this.attach_urls);
    },

  }
};
</script>

<style lang="scss">
.upload {
  .el-upload__tip {
    font-size: 12px;
    color: #999999;
    line-height: 25px;
  }
}
</style>
